import { render } from "./Banner.vue?vue&type=template&id=48eba853&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=48eba853&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48eba853"

export default script